import React, { FormEvent, useState } from 'react';
import { Link } from 'react-router-dom';
import Button from '../../components/Button/Button';
import Input from '../../components/Input/Input';
import superAdminAuthService from '../../services/superAdminAuth.service';
import './SuperAdminAuth.scss';

const SuperAdminForgotPassword: React.FC = () => {
  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const validate = (): boolean => {
    if (!email) {
      setEmailError('L\'email est obligatoire');
      return false;
    }
    setEmailError('');
    return true;
  };

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    if (!validate()) return;

    setIsLoading(true);
    setError('');
    try {
      await superAdminAuthService.requestPasswordReset(email.trim());
      setSent(true);
    } catch {
      setError('Une erreur est survenue. Veuillez réessayer.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="super-admin-auth">
      <div className="super-admin-auth__card">
        <p className="super-admin-auth__eyebrow">ZEEDCOM Control</p>
        <h1 className="super-admin-auth__title">Mot de passe oublié</h1>

        {sent ? (
          <>
            <p className="super-admin-auth__subtitle">Vérifiez votre boîte e-mail.</p>
            <div className="super-admin-auth__alert super-admin-auth__alert--success">
              Si un compte correspond à cet e-mail, un lien valable 1 heure a été envoyé.
            </div>
            <div className="super-admin-auth__footer">
              <Link to="/super-admin/login">Retour à la connexion</Link>
            </div>
          </>
        ) : (
          <>
            <p className="super-admin-auth__subtitle">
              Entrez votre adresse e-mail pour recevoir un lien de réinitialisation.
            </p>
            {error && <div className="super-admin-auth__alert super-admin-auth__alert--error">{error}</div>}
            <form className="super-admin-auth__form" onSubmit={handleSubmit}>
              <Input
                label="Email"
                type="email"
                name="email"
                value={email}
                onChange={(e) => { setEmail(e.target.value); setEmailError(''); setError(''); }}
                error={emailError}
                placeholder="votre@email.com"
                required
                fullWidth
                autoComplete="email"
              />
              <div className="super-admin-auth__actions">
                <Button type="submit" variant="primary" size="large" fullWidth loading={isLoading}>
                  Envoyer le lien
                </Button>
              </div>
            </form>
            <div className="super-admin-auth__footer">
              <Link to="/super-admin/login">Retour à la connexion</Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default SuperAdminForgotPassword;
